import { CHART_TYPES } from '@/composables/charts/influx-charts/chart-builders/CHART_TYPES'
import { SerializedCameraBasedChart } from '@/composables/charts/influx-charts/chart-builders/ChartInterfaces'
import { AbstractInfluxLineChartBuilder } from '@/composables/charts/influx-charts/chart-builders/AbstractInfluxLineChartBuilder'
import { TagSelector } from '@/composables/charts/influx-charts/query-builders/InfluxTypes'

export class CameraBasedInfluxLineChartBuilder extends AbstractInfluxLineChartBuilder {
  measurement: string
  field: string
  cameraTagSelector: TagSelector<'camera'>

  constructor(serialized: SerializedCameraBasedChart) {
    super(serialized)
    this.measurement = serialized.measurement
    this.field = serialized.field
    this.cameraTagSelector = serialized.cameraTagSelector
    this.setCamerasBasedQueryOptions()
  }

  setCamerasBasedQueryOptions() {
    const compiledTransientGroupByTags = this.transientGroupByTags ? this.transientGroupByTags : []
    if (this.cameraTagSelector.groupByValues) {
      compiledTransientGroupByTags.push('camera')
    }
    const compiledTransientWhereFilters = this.transientWhereClauses ? this.transientWhereClauses : {}
    if (!this.cameraTagSelector.useAll && this.cameraTagSelector.specificValues && this.cameraTagSelector.specificValues.length > 0) {
      compiledTransientWhereFilters.camera = this.cameraTagSelector.specificValues
    }
    this.transientWhereClauses = compiledTransientWhereFilters
    this.transientGroupByTags = compiledTransientGroupByTags
  }

  buildQuery() {
    return this.buildQueryForSingleQuery(this.measurement, this.field)
  }
  serialize(): SerializedCameraBasedChart {
    return {
      ...super.serialize(),
      measurement: this.measurement,
      field: this.field,
      chartType: CHART_TYPES.CAMERA_BASED_LINE,
      cameraTagSelector: this.cameraTagSelector,
    }
  }
  autoInferChartEntity(serialized?: SerializedCameraBasedChart): string | undefined {
    const localMeasurement = this.measurement ? this.measurement : serialized?.measurement
    if (!localMeasurement) return undefined
    return `frontend-charts.${localMeasurement}`
  }
}
